export default __webpack_public_path__ + "static/media/SuperShadows_06.6aa77d4f.png";